<template>
  <div id="app">
    <el-container>
      <!-- 顶部导航栏 -->
<!--        background-color: rebeccapurple;-->
      <div style="background-color:#663399 ">
        <el-header  class="nav">
          <div class="container" style="max-width: 1140px; height: 100%; margin: 0 auto;">
            <router-link  class="logo" to="/home">
<!--              <svg t="1665406332856" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4985"><path d="M883.658429 511.980261c40.661552-58.426308 74.019816-116.65523 98.100929-172.318131 57.044605-131.656579 56.25506-236.468638-2.368634-295.092332s-163.435753-59.413239-295.092332-2.368634c-55.465515 24.081113-113.694437 57.439377-172.318131 98.100929-58.426308-40.661552-116.65523-74.019816-172.318131-98.100929-131.656579-57.044605-236.468638-56.25506-295.092332 2.368634s-59.413239 163.435753-2.368634 295.092332c24.081113 55.465515 57.439377 113.694437 98.100929 172.318131-40.661552 58.426308-74.019816 116.65523-98.100929 172.318131-57.044605 131.656579-56.25506 236.468638 2.368634 295.092332 29.805312 29.805312 71.256409 44.609276 122.379429 44.609276 49.54393 0 107.970238-14.014418 172.91029-42.240642 55.465515-24.081113 113.694437-57.439377 172.318131-98.100929 58.426308 40.661552 116.65523 74.019816 172.318131 98.100929 64.940052 28.226223 123.36636 42.240642 172.910289 42.240642 50.925633 0 92.574116-14.803963 122.379429-44.609276 58.623694-58.623694 59.413239-163.435753 2.368634-295.092332-24.475886-55.662901-57.834149-113.852346-98.495702-172.318131z m-167.975635-397.33837c54.873357-23.686341 103.430356-35.726898 141.328502-35.726898 29.213154 0 52.10995 7.105902 66.519141 21.515093 33.160877 33.160877 27.831451 110.93103-14.211805 207.847643-19.146459 44.017117-44.609276 90.008096-75.598905 136.591233a1572.319056 1572.319056 0 0 0-120.208181-134.617372 1572.319056 1572.319056 0 0 0-134.617371-120.20818c46.583137-30.792243 92.771502-56.452446 136.788619-75.401519z m70.269479 397.33837a1512.846602 1512.846602 0 0 1-128.103628 145.868384 1442.083658 1442.083658 0 0 1-145.868384 128.103628 1512.846602 1512.846602 0 0 1-145.868383-128.103628 1467.013532 1467.013532 0 0 1-128.103628-145.868384 1512.846602 1512.846602 0 0 1 128.103628-145.868383 1467.013532 1467.013532 0 0 1 145.868383-128.103628 1512.846602 1512.846602 0 0 1 145.868384 128.103628 1442.083658 1442.083658 0 0 1 128.103628 145.868383z m-671.310382-203.702532c-42.043255-97.113998-47.372682-174.686765-14.211805-207.847643 14.409191-14.409191 37.305987-21.515093 66.519141-21.515093 37.898146 0 86.652531 12.040557 141.328502 35.726898 44.017117 19.146459 90.008096 44.609276 136.591233 75.598905a1598.413509 1598.413509 0 0 0-254.825552 254.825552c-30.792243-46.780524-56.25506-92.771502-75.401519-136.788619z m193.635838 601.040903c-97.113998 42.043255-174.686765 47.372682-207.847643 14.211805s-27.831451-110.93103 14.211805-207.847643c19.146459-44.017117 44.609276-90.008096 75.598905-136.591233a1572.319056 1572.319056 0 0 0 120.20818 134.617371 1572.319056 1572.319056 0 0 0 134.617372 120.208181c-46.583137 30.792243-92.771502 56.294537-136.788619 75.401519z m615.252708 14.211805c-33.160877 33.160877-110.93103 27.831451-207.847643-14.211805-44.017117-19.146459-90.008096-44.609276-136.591233-75.598905a1572.319056 1572.319056 0 0 0 134.617371-120.208181 1572.319056 1572.319056 0 0 0 120.208181-134.617371c30.98963 46.583137 56.452446 92.574116 75.598905 136.591233 41.885346 97.113998 47.175296 174.884151 14.014419 208.045029z" fill="#3390FF" p-id="4986"></path><path d="M511.980261 511.980261m-78.95447 0a78.95447 78.95447 0 1 0 157.90894 0 78.95447 78.95447 0 1 0-157.90894 0Z" fill="#231815" p-id="4987"></path></svg>-->
            <el-image :src="logo" alt="sss" style="width: 55px; height: 55px;margin-top: 3px" fit="fill">image</el-image>
<!--                <el-image src="<%= BASE_URL %>logo0.png" alt="sss" style="width: 50px; height: 50px" fit="fill">image</el-image>-->
              <!--            <img src="public/loag.jpg" style="width: 100px; height: 100px" alt="fail">-->
              <span style="font-size: 33px;">AIDrugDesigner </span>

            </router-link>
            <el-menu
                    class="el-menu-demo"
                    mode="horizontal"
                    :router="true"
                    @select="handleSelect"
                    text-color="#fff"
                    :default-active="$router.currentRoute.path"
                    active-text-color="#E6A23C"
                    background-color="#663399">
              <el-menu-item index="/home" class="item">Home</el-menu-item>
              <el-submenu index="/generation" class="item">
                <template slot="title"><span style="font-size: 20px">Generation</span></template>
<!--                  <el-submenu index="1">-->
<!--                      <template slot="title">Structure-based</template>-->
<!--                  </el-submenu>-->
                  <el-menu-item index="/generation/SBDD-3D" class="subitem">Structure-based</el-menu-item>
                  <el-menu-item index="/generation/SequenceBased" class="subitem">Sequence-based</el-menu-item>
                <el-menu-item index="/generation/phar-based" class="subitem">Phar-based</el-menu-item>
                <el-menu-item index="/generation/property-based" class="subitem">Property-based</el-menu-item>
                <el-menu-item index="/generation/linker-design" class="subitem">Linker design</el-menu-item>
              </el-submenu>
              <el-submenu index="/optimization" class="item">
                <template slot="title"><span style="font-size: 20px">Optimization</span></template>
                <el-menu-item index="/optimization/logP" class="subitem">LogP</el-menu-item>
                <el-menu-item index="/optimization/hydrophilic" class="subitem">Solubility</el-menu-item>
                <el-menu-item index="/optimization/QED" class="subitem">QED</el-menu-item>
                <el-menu-item index="/optimization/SA" class="subitem">SA</el-menu-item>
              </el-submenu>
              <el-menu-item class="item" index="/tutorial">Tutorial</el-menu-item>
              <el-menu-item class="item" index="/contact">Contact us</el-menu-item>
            </el-menu>
          </div>
        </el-header>
      </div>

      <!-- 路由页面 -->
      <el-main
              style="background-color: RGB(244,246,249)"
      >
        <router-view></router-view>
      </el-main>
      <!-- 底部版权页 -->
      <el-footer style="background-color: #363636; height: 210px" >
        <p class="copyright">Copyright @ 2016-CSU-Bioinformatics Group l All Right Reserved l</p>
        <p class="copyright">The platform integrates multiple third-party components under their respective open-source licenses.</p>
      </el-footer>
    </el-container>
  </div>




</template>
<script>


export default {
  name: 'app',
  components: {},
  data() {
    return {
      activeIndex: '/home',
      logo:'https://www.csuligroup.com/AIDrugDesigner/img/logo1_small.png',
    }
  },
  methods: {
    handleSelect() {

    }
  }
}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-size: 1.1rem;
  color: #2c3e50;
}

.subitem {
  font-size: 17px;
}

.item {
  font-size: 20px;
}

.copyright {
  padding-top: 20px;
  color: aliceblue;
  font-size: 22px;
  text-align: center;
  margin: 0 auto;
}

.el-menu-demo {
  float: right;
}

.logo {
  text-decoration: none;
  color: rgba(255, 255, 255, .8);
  display: flex;
  float: left;
}

.logo span {
  line-height: 60px;
}

.logo .icon {
  margin-top: 10px;
  margin-right: 15px;
  width: 40px;
  height: 40px;
}
</style>
